import I18N from '@leverege/i18n'
import { DataViewerModel } from '@leverege/molten/data-viewers'

import EventsView from '../events/EventsView'
import EventsViewModel from '../events/EventsViewModel'

import AisleSessionSupportDataViewer from './AisleSessionSupportDataViewer'

const { tf, tfIcon } = I18N.ns( 'ps.dataViewers.AisleSessionEventsDataViewer' )

export default {
  id : 'ps.dataViewers.AisleSessionEventsDataViewer',
  type : 'ps.AisleSessionEvents',
  name : tf( 'name', 'Aisle Sessions' ),
  icon : tfIcon( 'icon', 'fa fa-archive fa-fw' ),
  location : [ 'main', 'card' ],
  matches : { type : [ 'GroupDataViewer' ], objectType : 'aisle' },
  createSettings : ( props ) => {
    return EventsViewModel.create( {
      dataViewers : [ 
        DataViewerModel.create( 
          AisleSessionSupportDataViewer.type, 
          AisleSessionSupportDataViewer.createSettings( props ) )
      ],
      breakpoints : [ 'minWidth' ],
      useParent : false
    } )
  },
  component : EventsView,
  getDefaultCardContentOptions : { height : '400px' }
}
